import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import TimelineIcon from '@material-ui/icons/Timeline';

export const gcpUptimeRouteRef = createRouteRef();

const gcpUptimePage = PageBlueprint.make({
  params: {
    path: '/uptime',
    title: 'Uptime',
    icon: <TimelineIcon />,
    routeRef: gcpUptimeRouteRef,
    loader: () =>
      import('./GcpUptimePage').then(m => <m.GcpUptimePage />),
  },
});

export const gcpUptimePlugin = createFrontendPlugin({
  pluginId: 'gcp-uptime',
  extensions: [gcpUptimePage],
  routes: {
    root: gcpUptimeRouteRef,
  },
});
